import React, { useState, useEffect } from 'react';
import { object, func, bool, string } from 'prop-types';

import { CloneObject } from '../../../utils/helpers';
import { ALERT_TYPE, MASK_FORMAT, PATTERNS, REQUEST_METHOD, ShowToastMessage, useForm } from '@laramie/ui';
import { useLista } from '../../hooks/useLista';
import { InputLista, InputFormat, InputNumber, FormLabel, CheckboxButton, Modal, FormError } from '../../common';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';
import { useFormErrors } from '../../hooks/useFormErrors';
import DataTaggerFormRedux from '../DataTaggerFormRedux';
import { APIS } from '../../../config/apis';
import { standardRequest } from '../../../utils/requests';
import NumberFormat from 'react-number-format';
import { TIPS } from '../../../consts/tips';

const DocumentoModal = (props) => {

  const entityInit = {
    id: 0,
    idTipoPersona: 0,
    idPersona: 0,
    idTipoDocumento: 0,
    numeroDocumento: '',
    principal: false,
  };

  //hooks
  const [state, setState] = useState({
    entity: entityInit,
    showInfo: false,
    listDocumentos: []
  });

  const [documentoDuplicado, setDocumentoDuplicado] = useState(null);

  const mount = () => {
    setState(prevState => {
      return {...prevState, entity: props.data.entity };
    });
    formSet({
      idTipoDocumento: (props.data.entity.idTipoPersona === 501/*Juridica*/) ? 515 : props.data.entity.idTipoDocumento,
      numeroDocumento: props.data.entity.numeroDocumento,
      principal: props.data.entity.principal
    });

    setState(prevState => {
      return {...prevState, entity: props.data.entity, listDocumentos: props.data.listDocumentos}
    });
  }
  useEffect(mount, [props.data.entity, props.data.listDocumentos]);

  const [, getRowLista] = useLista({
    listas: ['TipoDocumento'],
    onLoaded: (listas, isSuccess, error) => {
      if (isSuccess) {
        setState(prevState => ({...prevState}));
      }
      else {
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
      }
    },
    memo: {
      key: 'TipoDocumento',
      timeout: 0
    }
  });

  const [ formValues, formHandle, , formSet ] = useForm({
    idTipoDocumento: 0,
    numeroDocumento: '',
    principal: false
  });

  const { errorOf, validate } = useFormErrors(getErrors, getFormatErrors);

  //handles
  const handleClickAceptar = async () => {
    if (!validate()) return;

    let row = CloneObject(state.entity);
    row.idTipoDocumento = parseInt(formValues.idTipoDocumento);
    row.numeroDocumento = formValues.numeroDocumento.replace(/-/g,'');
    row.principal = formValues.principal;

    if (state.entity.idTipoPersona === 500/*PersonaFisica*/) {
      try {
        const path = APIS.URLS.PERSONA_FISICA +
          `/check-documento-duplicado?idTipoDocumento=${row.idTipoDocumento}` +
          `&numeroDocumento=${encodeURIComponent(row.numeroDocumento)}` +
          `&excludeIdPersona=${state.entity.idPersona || 0}`;
        const data = await standardRequest(REQUEST_METHOD.GET, path, null, { disableToast: true });
        if (data.duplicado) {
          const nombre = [data.persona?.nombre, data.persona?.apellido].filter(Boolean).join(' ');
          setDocumentoDuplicado({
            idTipoDocumento: row.idTipoDocumento,
            numeroDocumento: row.numeroDocumento,
            message: `Ya existe una persona física con ese documento${nombre ? ': ' + nombre : ''}`
          });
          return;
        }
      } catch (error) {
        // Si falla la verificación, no bloquear al usuario
      }
    }

    props.onConfirm(row);
  };

  //funciones
  function getErrors() {

    const errors = {};

    if (formValues.idTipoDocumento <= 0) errors.idTipoDocumento = VALIDATION_MESSAGE.REQUIRED_OPTION;
    if (formValues.numeroDocumento.length <= 0) errors.numeroDocumento = VALIDATION_MESSAGE.REQUIRED;

    const numeroNormalizado = formValues.numeroDocumento.replace(/-/g,'');
    let existeDocumento = false;
    state.listDocumentos.forEach(x => {
      if ((x.numeroDocumento === numeroNormalizado) && (x.idTipoDocumento === formValues.idTipoDocumento)){ 
        existeDocumento = true;
        return;
      }
    });

    if (existeDocumento) errors.numeroDocumento = 'El Número y Tipo de documento ya existe';

    return errors;
  }

  function getFormatErrors() {

    const errors = {};

    if (documentoDuplicado
      && documentoDuplicado.idTipoDocumento === parseInt(formValues.idTipoDocumento)
      && documentoDuplicado.numeroDocumento === formValues.numeroDocumento.replace(/-/g,'')) {
      errors.numeroDocumento = documentoDuplicado.message;
    }

    return errors;
  }

  const getDescTipoDocumento = (id) => {
    const row = getRowLista('TipoDocumento', id);
    return (row) ? row.nombre : '';
  }

  function ToggleAccordionInfo() {
    setState(prevState => {
      return {...prevState, showInfo: !prevState.showInfo};
    });
  }
   
  const accordionClose = <span className="material-symbols-outlined search-i">chevron_right</span>
  const accordionOpen = <span className="material-symbols-outlined search-i">expand_more</span>

  return (
    <>

    <Modal
      size="lg"
      title={`Documento: ${(state.entity.id > 0) ? `${getDescTipoDocumento(state.entity.idTipoDocumento)} ${state.entity.numeroDocumento}` : "Nuevo"}`}
      tipName={TIPS.NAME.MODALS.DOCUMENTO_MODAL}
      onEscape={() => props.onDismiss()}
      body={(
            <div className="row">
                
                <div className="col-12 col-lg-5">
                    <FormLabel htmlFor="idTipoDocumento" required>Tipo de documento</FormLabel>
                    <InputLista
                        name="idTipoDocumento"
                        placeholder=""
                        className={`form-control ${errorOf('idTipoDocumento') ? 'is-invalid' : ''}`}
                        value={ formValues.idTipoDocumento }
                        onChange={({target}) => {
                          formSet({...formValues,
                            idTipoDocumento: target.value,
                            numeroDocumento: ''
                          });
                        }}
                        disabled={(state.entity.idTipoPersona === 501/*Juridica*/) ? true : props.disabled}
                        lista="TipoDocumento"
                    />
                    <FormError message={errorOf('idTipoDocumento')} />
                </div>
                <div className="col-8 col-lg-5">
                    <FormLabel htmlFor="numeroDocumento" required>Número de documento</FormLabel>
                        <InputFormat
                            name="numeroDocumento"
                            placeholder=""
                            className={`form-control ${errorOf('numeroDocumento') ? 'is-invalid' : ''}`}
                            mask={(formValues.idTipoDocumento === 510/*DNI*/) ? MASK_FORMAT.DNI :
                                  (formValues.idTipoDocumento === 515/*CUIL*/) ? MASK_FORMAT.CUIT : MASK_FORMAT.PASAPORTE}
                            maskPlaceholder={null}
                            value={ formValues.numeroDocumento }
                            onChange={ formHandle }
                            disabled={props.disabled}
                        />
                    <FormError message={errorOf('numeroDocumento')} />
                </div>
                <div className="mb-3 col-12">
                    <CheckboxButton
                        name="principal"
                        label="Documento principal"
                        checked={formValues.principal}
                        onChange={formHandle}
                        disabled={props.disabled}
                    />
                </div>

                <div className="m-top-20 mb-3 col-12">
                  <div className='accordion-header'>
                    <div className='row'>
                      <div className="col-12" onClick={() => ToggleAccordionInfo()}>
                        <div className='accordion-header-title'>
                          {(state.showInfo) ? accordionOpen : accordionClose}
                          <h3 className={state.showInfo ? 'active' : ''}>Información adicional</h3>
                        </div>
                      </div>
                    </div>
                  </div>
                  {state.showInfo &&
                  <div className='accordion-body'>
                    <DataTaggerFormRedux
                        title="Información adicional de documento"
                        processKey={props.processKey}
                        entidad="Documento"
                        idEntidad={state.entity.id}
                        disabled={props.disabled}
                    />
                  </div>
                  }
                </div>                

            </div>
      )}
      footer={!props.disabled ? (<>
              <button className="btn btn-outline-primary" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Cancelar</button>
              <button className="btn btn-primary" data-dismiss="modal" onClick={ (event) => handleClickAceptar() }>Aceptar</button>
      </>) : (
              <button className="btn back-button" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Volver</button>
      )}
      footerClassName={props.disabled ? 'f-align' : ''}
    />

    </>
  );
}

DocumentoModal.propTypes = {
  processKey: string.isRequired,
  disabled: bool,
  data: object.isRequired,
  onConfirm: func.isRequired,
  onDismiss: func.isRequired,
};

DocumentoModal.defaultProps = {
  disabled: false
};

export default DocumentoModal;